import {
  ConversationEventsRefreshPayload,
  GlobalEventType,
} from '@src/types';
import { EventBus } from './event-bus';

export const emitConversationEventsRefresh = (
  payload: ConversationEventsRefreshPayload,
) => {
  if (!payload.conversationId) {
    return;
  }
  EventBus.emit(GlobalEventType.CONVERSATION_EVENTS_REFRESH, payload);
};

export const shouldHandleConversationEventsRefresh = (
  currentConversationId: string,
  payload?: ConversationEventsRefreshPayload | null,
) => {
  if (!currentConversationId || !payload?.conversationId) {
    return false;
  }
  return payload.conversationId === currentConversationId;
};
